import React, { useState, useEffect, useCallback, useRef } from 'react';
// 아이콘 사용을 위해 react-icons/fa를 사용합니다.
import { FaPencilAlt, FaCamera, FaThumbsUp } from 'react-icons/fa';

import {  MdOutlineIosShare, MdOutlineCameraAlt } from "react-icons/md";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import { FaHeart } from "react-icons/fa";

import { useSearchParams, useNavigate } from 'react-router-dom';

import InfiniteScroll from 'react-infinite-scroll-component';

import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

import ImagePopup from '../components/ImagePopup';

import { getrecommendings } from '../network/get_recommendings';
import { getrecommedailylook } from '../network/get_recommdailylook';
import { getpickMoodPosts } from '../network/get_pickMoodPost';
import { getwishes } from '../network/get_wishes';

import { getweeklybest } from '../network/get_weeklybest';
import { postWeeklyBestVote } from '../network/post_weeklyBestVote';
import { postWeeklyBestMyVote } from '../network/post_weeklyBestMyVote';
import { getMonthBest } from '../network/get_monthBest';

import { postVote } from '../network/post_Vote';

import { MY_URL } from '../client';

import { MoonLoader
 } from 'react-spinners';

const TOAST_DURATION = 2000; // 2초


// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 


// 탭 항목 정의
const TABS = [
  { key: 'rating', label: '평가' },
  { key: 'recommend', label: '추천' },
  { key: 'favorite', label: '찜' },
    { key: 'vote', label: '투표' },
];




const Vote_page = () => {
          const navigate = useNavigate();

                     async function vote(id) {
            console.log(id)

            await postVote(id)
            await processData()

           }

            const goToPostDetail = (postId, postCategory) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: postId,
      category: postCategory
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/dailylook?${queryParams}`);
  };


const [weeklyBestData, setWeeklyBestData] = useState([]);
const [voteCounts, setVoteCounts] = useState([]);
const [myVoteStatus, setMyVoteStatus] = useState([]);

     const [activeTab, setActiveTab] = useState('vote');


         const [isPopupOpen, setIsPopupOpen] = useState(false);
         const [isLoading, setIsLoading] = useState(false);



                  const [wishData, setWishData] = useState({ brands: [], malls: [] });
const [monthBestData, setMonthBestData] = useState([]);







const [activeVoteView, setActiveVoteView] = useState('weekly'); 

  // ⭐️ VOTE 뷰 전환 로직
  const handleVoteViewSwitch = (viewKey) => {
    setActiveVoteView(viewKey);
    console.log(`투표 뷰 전환: ${viewKey}`);
    // 여기에 뷰 전환 시 데이터 초기화 로직 (필요하다면) 추가
  };





     const handleClosePopup = () => {
        setIsPopupOpen(false);
    };



           //const navigate = useNavigate();




async function processData() {
    try {
        const weeklyBest = await getweeklybest();
        const idsToProcess = weeklyBest.map(item => item.id);
        const monthsbest = await getMonthBest()
        console.log(monthsbest.results)
        
        // 투표 수, 내 투표 여부를 비동기로 병렬 처리
        const [votecountRes, myvoteRes] = await Promise.all([
             postWeeklyBestVote(idsToProcess),
             postWeeklyBestMyVote(idsToProcess)
        ]);

        // ⭐️ 응답 문자열을 배열로 변환 및 숫자로 파싱
        const counts = votecountRes.split(',').map(s => parseInt(s.trim())).filter(n => !isNaN(n));
        const myVotes = myvoteRes.split(',').map(s => parseInt(s.trim())).filter(n => !isNaN(n));

        // ⭐️ 상태 업데이트
        setWeeklyBestData(weeklyBest);
        setVoteCounts(counts);
        setMyVoteStatus(myVotes);
        setMonthBestData(monthsbest.results || []);
        
    } catch (error) {
        console.error("투표 데이터 로드 실패:", error);
        setIsLoading(false);
    }
}





const handleNavigation = (tabKey) => {
    // ⭐️ 1. TABS의 key를 기반으로 경로를 설정합니다.
    const path = `/${tabKey}`;

    // 2. '/profile' 등의 특별 경로 처리 (이전 로직 유지)
    if (path === '/profile') {
        const savedToken = localStorage.getItem('user');
        const storedUserObject = JSON.parse(savedToken);
        
        // 토큰 체크 로직 강화 (null 또는 파싱 실패 대비)
        if (!storedUserObject || storedUserObject.username === 'temp') {
            navigate('/login');
        } else {
            // 실제 프로필 페이지로 이동 (예시: 사용자 ID와 함께)
            navigate(`/profile?id=${storedUserObject.username}`); 
        }
    } else {
        // 3. 일반적인 탭 경로 이동
        navigate(path);
    }
    console.log(`페이지 이동 요청: ${path}`);
};




    useEffect(() => {

      
      processData()
  
    }, []);



if (!weeklyBestData) {
    // API 호출이 완료되었는데 데이터가 없는 경우를 고려하여 로딩 UI 표시
    return <div style={styles.loadingContainer}>찜 목록을 불러오는 중...</div>;
}
    

    function ShareButton({ linkToCopy }) {
      // 1. 토스트 메시지 표시 상태 관리
      const [showToast, setShowToast] = useState(false);
    
      // 2. 복사 및 알림을 처리하는 단일 함수
      const handleCopy = async () => {
        if (!linkToCopy) {
          console.error("복사할 링크가 없습니다.");
          return;
        }
    
        try {
          // ⭐️ 클립보드 API를 사용하여 링크 복사
          await navigator.clipboard.writeText(linkToCopy);
    
          // ⭐️ 복사 성공 시 토스트 메시지 표시
          setShowToast(true);
    
          // ⭐️ 일정 시간 후 토스트 메시지 숨김
          setTimeout(() => {
            setShowToast(false);
          }, TOAST_DURATION);
    
        } catch (err) {
          console.error('클립보드 복사 실패:', err);
          alert('클립보드 복사에 실패했습니다. 브라우저 권한을 확인해주세요.');
        }
      };
    
      return (

    <>
                  <MdOutlineIosShare size="24"  onClick={handleCopy} style={{
            marginLeft: '15px', // 아이콘 간의 간격
            cursor: 'pointer',
            marginRight:'5pt'
        }} />
    
    
          {/* ⭐️ 토스트 메시지 (조건부 렌더링) */}
          {showToast && (
            <div style={styles.toast}>
              링크를 복사했습니다. ✅
            </div>
          )}
</>
      );
    }

  return (
    // 메인 컨테이너: 상단 고정 및 양 끝 정렬

 <div>
          <ImagePopup 
                      isOpen={isPopupOpen} 
                      onClose={handleClosePopup} 
                  />

    {!isLoading && (
    <header style={styles.header}>

      <div style={{display : 'flex', justifyContent:'space-between'}}>
      
      {/* 1. 왼쪽 탭 그룹 (Flex) */}
      <div style={styles.tabGroup}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          
          return (
            <div 
          key={tab.key} 
          // ⭐️ onClick 이벤트 핸들러 수정: tab.key를 인자로 전달
          onClick={() => handleNavigation(tab.key)} 
          style={styles.tabItem}
        >
              {/* 탭 텍스트 */}
              <span style={{ 
                ...styles.tabText,
                color: isActive ? styles.colors.activeText : styles.colors.inactiveText,
                fontWeight: isActive ? 'bold' : 'normal'
              }}>
                {tab.label}
              </span>
              
              {/* 활성 탭 밑줄 */}
              <div style={{
                ...styles.tabUnderline,
                // 활성 탭에만 검은색 선을 표시하고, 나머지는 투명하게 숨김
                backgroundColor: isActive ? styles.colors.activeUnderline : 'transparent'
              }} />
            </div>
          );
        })}
      </div>
      
      {/* 2. 오른쪽 아이콘 그룹 (Flex) */}
      <div style={styles.iconGroup}>
        {/* 연필 아이콘 */}
        {/* <FaPencilAlt 
          size={22} 
          color={styles.colors.icon} 
          onClick={() => setIsPopupOpen(true)}
          style={{marginLeft: '15px', // 아이콘 간의 간격
        cursor: 'pointer', marginRight : '10pt'}}
        /> */}
        
        {/* 돋보기 아이콘 */}
        <MdOutlineCameraAlt 
          size={22} 
          color={styles.colors.icon} 
          onClick={() => setIsPopupOpen(true)}
          style={styles.iconStyle}
        />
      </div>
      </div>
    </header>

    

    

    

    
    )}

    <div style={styles.voteSwitchWrapper}>
            
            {/* 주간 모디 버튼 (활성 상태) */}
            <button 
                onClick={() => handleVoteViewSwitch('weekly')}
                style={activeVoteView === 'weekly' ? styles.voteSwitchActive : styles.voteSwitchButton}
            >
                주간 모디
            </button>
            <span style={{marginLeft:'10px'}}></span>

            {/* 투표 현황 버튼 (비활성 상태) */}
            <button 
                onClick={() => handleVoteViewSwitch('status')}
                style={activeVoteView === 'status' ? styles.voteSwitchActive : styles.voteSwitchButton}
            >
                투표 현황
            </button>
        </div>

        <main style={styles.mainContent}>
            
            {/* ⭐️ 조건부 렌더링: 활성화된 뷰에 따라 내용을 표시 */}
            {activeVoteView === 'weekly' ? (
                // 주간 모디 (기존의 InfiniteScroll 내용)
               <div style={styles.weeklyVoteContent}>
            
            {/* 제목 및 공유 버튼 */}
            <div style={styles.voteHeaderRow}>
                <h2 style={styles.voteTitle}>이번주 주간 모디</h2>
                 <ShareButton linkToCopy= {MY_URL + '/vote'} />
            </div>
            <span style={styles.voteSubtitle}>엄지를 눌러 투표에 참여하세요 🎖️</span>

              {weeklyBestData.length > 0 ? 
            <div style={styles.gridContainer}>
                
                {/* 1. 상단 2개의 아이템 (2x1 배치) */}
                <div style={styles.topTwoGrid}>
                  
                    {weeklyBestData.slice(0, 2).map((item, index) => (
                      <div style={styles.imageCardWrapper}>
                        <VoteImageCard 
                            key={item.id}
                            item={item}
                            rank={index + 1}
                            voteCount={voteCounts[index] || 0}
                            hasVoted={myVoteStatus[index] === 1}
                            onVote={() => {
                                const newVoteCounts = [...voteCounts];
                                const newmyVoteStatus = [...myVoteStatus];


                                        if (myVoteStatus[index] == 1){
                                        newmyVoteStatus[index] = +!newmyVoteStatus[index]; 
 
                                        newVoteCounts[index] = newVoteCounts[index] - 1; 
                                        }else{
                                        newmyVoteStatus[index] = +!newmyVoteStatus[index]; 
 
                                        newVoteCounts[index] = newVoteCounts[index] + 1; 
                                        }


                                       setMyVoteStatus(newmyVoteStatus)
                                        setVoteCounts(newVoteCounts);

                                        const savedToken = localStorage.getItem('user');
                                    const storedUserObject = JSON.parse(savedToken);
                                
                                                if (!storedUserObject || storedUserObject.username === 'temp') {
                                                    navigate('/login');
                                                }else{
                                                        vote(item.id)
                                                }
                                                    
                            }
                            }
                            isLarge={true}
                        />
                        <GenderBadge gender={item.user?.gender} rank={1} />
                         </div>
                    ))}
                </div>
              

                {/* 2. 하단 9개의 아이템 (3x3 배치) */}
                <div style={styles.bottomNineGrid}>
                    {weeklyBestData.slice(2, 11).map((item, index) => {
                        const globalIndex = index + 2; // 전체 순위 3번부터 시작
                        return (
                            <VoteImageCard 
                                key={item.id}
                                item={item}
                                rank={globalIndex + 1} // 순위 번호 3, 4, 5...
                                voteCount={voteCounts[globalIndex] || 0}
                                hasVoted={myVoteStatus[globalIndex] === 1}
                                onVote={() => {

                                   const newVoteCounts = [...voteCounts];
                                const newmyVoteStatus = [...myVoteStatus];


                                        if (myVoteStatus[index + 2] == 1){
                                        newmyVoteStatus[index + 2] = +!newmyVoteStatus[index + 2]; 
 
                                        newVoteCounts[index + 2] = newVoteCounts[index + 2] - 1; 
                                        }else{
                                        newmyVoteStatus[index + 2] = +!newmyVoteStatus[index + 2]; 
 
                                        newVoteCounts[index + 2] = newVoteCounts[index + 2] + 1; 
                                        }


                                       setMyVoteStatus(newmyVoteStatus)
                                        setVoteCounts(newVoteCounts);

                                        const savedToken = localStorage.getItem('user');
                                    const storedUserObject = JSON.parse(savedToken);
                                
                                if (!storedUserObject || storedUserObject.username === 'temp') {
                                    navigate('/login');
                                }else{
                                                        vote(item.id)
                                }
                            }}
                            gotoPost= {() => goToPostDetail(item.id,'d')}
                                
                                
                                isLarge={false}
                            />
                        );
                    })}
                </div>
            </div>
            :
            <div style={{
                                  display: 'flex',
                    justifyContent: 'center', // 가로 중앙 정렬
                    alignItems: 'center',
                    flexDirection: "column",
                    marginTop : '30px'
            
                                }}>
                                <MoonLoader
            
                                    color="#007bff" // 원하는 색상
                                    loading={true}
                                    size={30}
                                    aria-label="Loading Spinner"
                                  />
                                  
                                <p>로딩 중</p>
                                </div>

            }

        </div>
            ) : (
                // 투표 현황 (새로운 현황 페이지 내용)
           <div style={styles.voteStatusContent}>
        
        <h2 style={{        fontSize: '20px',
        fontWeight: 'bold', marginLeft:'15px', marginTop:'0',marginBottom:'5px'}}>월간 모디 투표</h2>
        <span style={{            fontSize: '14px',
        color: '#ff4d4f', // 붉은색
        padding: '0 15px', // 붉은색
        }}>월간 누적 투표 순위에요✨</span>

        <div style={styles.gridContainer}>
            
            {/* 1. 상단 2개의 아이템 (2x1 배치) */}
            <div style={styles.topTwoGrid}>
                {/* ⭐️ monthBestData의 처음 2개 항목 사용 */}
                {monthBestData.slice(0, 2).map((item, index) => (
                    <VoteStatusCard 
                        key={item.id}
                        item={item}
                        rank={index + 1}
                        isLarge={true}
                    />
                ))}
            </div>

            {/* 2. 하단 9개의 아이템 (3x3 배치) */}
            <div style={styles.bottomNineGrid}>
                {/* ⭐️ monthBestData의 3번째부터 11번째 항목 사용 */}
                {monthBestData.slice(2, 11).map((item, index) => {
                    const globalIndex = index + 2; // 전체 순위 3번부터 시작
                    return (
                        <VoteStatusCard 
                            key={item.id}
                            item={item}
                            rank={globalIndex + 1} // 순위 번호 3, 4, 5...
                            isLarge={false}
                        />
                    );
                })}
            </div>
        </div>

        {/* 🚨 데이터가 충분하지 않을 경우 메시지 */}
        {monthBestData.length === 0 && (
            <p style={styles.noDataText}>월간 베스트 데이터가 아직 없습니다.</p>
        )}
    </div>
            )}
            
        </main>

    


</div>



  );

  function VoteImageCard({ item, rank, voteCount, hasVoted, onVote, isLarge, gotoPost }) {
    
    // 이미 투표했으면 빨간색, 아니면 회색
    const thumbColor = hasVoted ? '#e74c3c' : '#ffffff';


    
    return (
        <div 
            style={isLarge ? styles.largeCard : styles.smallCard} 
            
        >
            <img 
                src={item.image} 
                alt={`순위 ${rank}`} 
                style={styles.imageItem} 
                onClick={() => goToPostDetail(item.id,'d')}
            />
            
            {/* 순위 번호 오버레이 (좌상단) */}
            {/* <div style={styles.rankBadge}>
                {rank}
            </div> */}
            
            {/* 투표 아이콘 및 카운트 오버레이 (우하단) */}
            <div style={styles.voteOverlay} onClick={onVote}>
                <FaThumbsUp 
                    size={10} 
                    color={thumbColor} 
                    style={{marginRight: '4px'}}
                    
                
                />
                <span style={{ color: 'white', fontSize: '12px' }}>
                    {voteCount}
                </span>
            </div>
        </div>
    );
}

function VoteStatusCard({ item, rank, isLarge }) {
    
    return (
        <div 
            style={isLarge ? styles.largeCard : styles.smallCard} 
        >
            <img 
                src={item.image} 
                alt={`순위 ${rank}`} 
                style={styles.imageItem} 
                onClick={() => goToPostDetail(item.id,'d')}
            />
            
            {/* ⭐️ 순위 번호 오버레이 (좌상단) */}
            <div style={styles.rankBadge}>
                {rank}
            </div>
            
            {/* ❌ 투표 숫자와 엄지 아이콘 오버레이는 제외 */}
        </div>
    );
}

  function GenderBadge({ gender, rank }) {
    // 성별에 따른 텍스트 결정
    const genderText = gender === 'W' ? '여성' : '남성';
    const backgroundColor = gender === 'W' ? '#000000a8' : '#000000a8'; // 이미지와 같이 어두운 배경 사용

    return (
        <div style={{ ...badgeStyles.badgeContainer, backgroundColor }}>
            <span style={badgeStyles.rank}>{rank}</span>
            <span style={badgeStyles.gender}>{genderText}</span>
        </div>
    );
}


};




// ----------------------------------------------------
// 스타일 정의
// ----------------------------------------------------


const badgeStyles = {
    badgeContainer: {
        position: 'absolute', // ⭐️ 필수: 부모(imageCardWrapper) 기준으로 위치 지정
        top: 5,
        left: 5,
        backgroundColor: '#4A4A4A', // 진한 회색 배경
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: '6px 10px',
        borderRadius: '8px', // 오른쪽 하단 모서리만 둥글게
        fontSize: '10px',
        fontWeight: 'bold',
        zIndex: 10, // 이미지 위에 표시
        flexDirection: 'column'
    },
    rank: {
       
        fontSize: '18px',
    },
    gender: {
        //
    }
};


const styles = {

      imageCardWrapper: {
        position: 'relative', // 👈 핵심
        //width: '49%', // dailylooksGrid의 gap과 맞춰 너비 조정
        borderRadius: '8px',
        overflow: 'hidden',
    },


 // 기존 스타일을 상속받음
    
    // ----------------- 상단 영역 -----------------
          toast: {
        position: 'fixed', // 화면에 고정
        bottom: '20px',    // 하단 20px 위치
        left: '50%',
        transform: 'translateX(-50%)', // 가로 중앙 정렬
        backgroundColor: 'rgba(50, 50, 50, 0.9)',
        color: 'white',
        padding: '10px 10px',
        borderRadius: '8px',
        zIndex: 9999,
        opacity: 1,
        fontSize: 13,
        transition: 'opacity 0.3s ease-in-out',
    },

    voteSwitchWrapper: {
        // fixed 헤더 바로 아래에 위치하도록 상단 패딩 처리
        padding: '10px 5vw', 
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        maxWidth: '420px',
        margin: '0 auto',
        backgroundColor: 'white', // 배경색 지정
        zIndex: 9, // 헤더보다 아래에 위치
        position: 'fixed', // 헤더처럼 고정
        top: '70px' // 헤더 높이(50px) + 구분선/패딩
    },

    // ⭐️ 기본 버튼 스타일 (흰 배경, 회색 텍스트)
    voteSwitchButton: {
        backgroundColor: 'transparent',
        color: '#a0a0a0', // 비활성 회색
        border: 'none',
        padding: '6px 12px',
        borderRadius: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'color 0.2s, background-color 0.2s',
    },

    // ⭐️ 활성 버튼 스타일 (주간 모디: 검은색 배경)
    voteSwitchActive: {
        backgroundColor: '#000000',
        color: 'white',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
    
   voteSwitchWrapper: {
        // ... (기존 fixed 스타일 유지)
        padding: '70px 0 0 15px', 
        top: '50px', // 헤더 높이(50px) 바로 아래
       
    },
    
    mainContent: {
        // voteSwitchWrapper 높이(약 40px) + 헤더 높이(50px) + 여백(20px) = 110px
        paddingTop: '110px', 
        padding: '110px 1vw 20px 1vw',
    },

    voteHeaderRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 15px',
        marginBottom: '5px',
    },
    voteTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0,
    },
    voteSubtitle: {
        fontSize: '14px',
        color: '#ff4d4f', // 붉은색
        padding: '0 15px',
    },

    // ----------------- 이미지 그리드 -----------------
    gridContainer: {
        padding: '0 15px',
        marginTop:'5px'
        
    },
    topTwoGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr', // 1:1 비율
        gap: '3px',
        marginBottom: '8px',
    },
    bottomNineGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', // 3:3:3 비율
        gap: '3px',
        marginTop:'30px'
    },

    
    
    // ----------------- 카드 공통 스타일 -----------------
    imageItem: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    },
    largeCard: {
        position: 'relative',
        //width: '100%',
        height: '100%',
        // 상단 2개 카드는 높이를 키우기 위해 aspect ratio 트릭 사용
        //paddingBottom: '130%', // 높이를 너비의 130%로 설정하여 세로가 긴 이미지에 맞춤
        backgroundColor: '#eee',
        
        overflow: 'hidden',
        cursor: 'pointer',
    },
    smallCard: {
        overflow: 'hidden',
        height: '160px',
        cursor:'pointer',
        position:'relative'
    },
    rankBadge: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        backgroundColor: '#000',
        color: 'white',
        padding: '3px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    voteOverlay: {
        position: 'absolute',
        bottom: '8px',
        right: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '4px 8px',
        borderRadius: '15px',
        display: 'flex',
        alignItems: 'center',
    },
    
    // ⭐️ 메인 콘텐츠 상단 패딩 조정
    mainContent: {
        // 기존 60px에서 voteSwitchWrapper 높이(약 40px) + 여백만큼 추가
        paddingTop: '110px', // 50px(헤더) + 40px(버튼 그룹) + 20px(여백)
        padding: '110px 1vw 20px 1vw', // 상단 패딩 조정
    },

  mainContent: {
        // 고정 Header 높이만큼 paddingTop을 확실히 적용
        paddingTop: '50px', // Header 높이 50px 가정
        padding: '50px 3vw 20px 3vw', // 상단 패딩을 명시적으로 설정
    },
    
    wishSection: {
        marginBottom: '20px',
    },
    wishTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#ff4d4f', // 이미지의 빨간색
        //margin: '0 0 15px 0',
    },
    listWrapper: {
        // 목록 전체를 감싸는 Wrapper (스크롤 가능한 경우 overflow-y: auto)
        // 현재는 전체 페이지가 스크롤되므로 별도의 스크롤 속성은 제외
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 0',
        borderBottom: '1px solid #f0f0f0', // 항목 간 구분선
    },
    itemInfo: {
        display: 'flex',
        flexDirection: 'column',
    },
    itemName: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000',
        marginBottom: '2px',
    },
    itemHashtag: {
        fontSize: '13px',
        color: '#888', // 회색 텍스트
    },
    heartIcon: {
        cursor: 'pointer',
    },
    sectionDivider: {
        height: '1px',
        backgroundColor: '#f0f0f0',
        margin: '30px 0',
    },
    noDataText: {
        textAlign: 'center',
        color: '#aaa',
        padding: '20px 15px',
    },

  filterSection: {
        // paddingTop은 헤더에 가려지지 않도록 이미 mainContent에서 처리되었으므로 필요 없음.
        padding: '10px 0',
        //marginTop: '130px', // 헤더 영역과 검색창 아래 여백을 위해 임시 설정
    },
    
    // ⭐️ 드롭다운 컨테이너 (가로 스크롤 및 배치)
    dropdownsWrapper: {
        display: 'flex',
        //overflowX: 'scroll', // 가로 스크롤 가능
        paddingBottom: '10px',
        gap: '8px', // 드롭다운 버튼 사이 간격
        // 스크롤바 숨기기 (필요 시)
        // msOverflowStyle: 'none', // IE and Edge
        // scrollbarWidth: 'none', // Firefox
    },
    
    // ⭐️ 드롭다운 버튼 공통 스타일 (이미지처럼 검은 테두리와 흰 배경)
    dropdownButton: {
        // ... (기존 스타일 유지) ...
        
        border: '1px solid #333', // 검은색 테두리
        borderRadius: '8px',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap', // 버튼 내용 줄바꿈 방지
    },
    
    // ⭐️ 키 설정 버튼 스타일 (Dropdown과 동일하게 보이도록 복사)
    heightButton: {
        border: '1px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },
    // ⭐️ 무드 설정 버튼 스타일 (Dropdown과 동일하게 보이도록 복사)
    moodButton: {
        border: '1px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },

    // ----------------- 선택된 태그 스타일 -----------------
    selectedTagsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginTop: '10px',
    },
    selectedTag: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff0f0', // 이미지의 연한 핑크 배경
        color: '#333',
        padding: '6px 10px',
        borderRadius: '15px', // 둥근 모서리
        fontSize: '14px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
    },
    removeTagButton: {
        marginLeft: '6px',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#333',
        fontWeight: 'bold',
        fontSize: '12px',
        cursor: 'pointer',
        padding: 0,
        lineHeight: 1,
    },

mainContent: {
        paddingTop: '60px', // Header 높이 + 여백
        padding: '20px 0 20px 0', // 상단 패딩을 확실히 줍니다.
    },
    
    // ----------------- 추천 섹션 공통 스타일 -----------------
    section: {
        marginBottom: '30px',
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        margin: '0 0 5px 0',
    },
    sectionSubtitle: {
        fontSize: '14px',
        color: '#ff4d4f', // 이미지의 붉은색
        margin: '0 0 15px 0',
    },
    sectionDivider: {
        height: '1px',
        backgroundColor: '#f0f0f0',
        margin: '30px 0',
    },
    
    // ----------------- 데일리룩 그리드 스타일 -----------------
    dailylookGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', // 3열 배치
        gap: '8px', // 이미지 간 간격
        width: '100%',
    },
    dailylookImageItem: {
        width: '100%',
        height: '130px', // 고정 높이 또는 비율을 위해 padding-bottom 사용 가능 (여기서는 고정)
        objectFit: 'cover', // 이미지가 잘리지 않게 영역을 채움
        borderRadius: '5px',
        cursor: 'pointer',
    },

    // ----------------- 목록 아이템 스타일 -----------------
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0',
        borderBottom: '1px solid #f9f9f9', // 아이템 간 얇은 구분선
    },
    itemName: {
        fontSize: '16px',
        fontWeight: '500',
        color: '#333',
    },
    heartIcon: {
        color: '#b0b0b0', // 회색 하트
    },


darkOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30%', // 이미지 높이의 약 30%를 검은색으로 덮음
        backgroundImage:'linear-gradient(0deg, black, transparent)',
        opacity: 0.9, // 약간의 투명도를 주어 자연스럽게 보이게 함
        zIndex: 1, // 별 아이콘보다 아래에 있어야 함
    },
    // 4. 별점 아이콘 그룹 스타일
    starGroup: {
        position: 'absolute',
        bottom: '10px', // 하단으로부터의 간격 조정
        left: '50%',
        transform: 'translateX(-50%)', // 중앙 정렬
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px', // 별 사이 간격
        width: '90%', // 별 그룹의 너비
        zIndex: 2, // 검은색 오버레이 위에 표시
    },
    starIcon: {
      width :'70',
      height :'70'
        // 추가 스타일이 필요하다면 여기에 정의
    },

    colors: {
        background: '#ffffff',
        border: '#d4d4d4ff',
        activeText: '#000000',
        inactiveText: '#a0a0a0', // 사진 속 회색 텍스트
        activeUnderline: '#000000',
        icon: '#000000'
    },
    header: {
        // 상단 고정 설정
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        
        // 레이아웃 설정
        display: 'flex',
        justifyContent: 'space-between', // 왼쪽 탭 그룹과 오른쪽 아이콘 그룹 분리
        alignItems: 'center',
        
        // 크기 및 외관
        height: '50px',
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${'#d4d4d4ff'}`, // 하단 구분선
        padding: '0 15px', // 좌우 패딩
        maxWidth: '420px', // 모바일 최대 너비
        margin: '0 auto', // 중앙 정렬
        zIndex: 10, // 다른 콘텐츠 위에 표시
    },
    tabGroup: {
        display: 'flex',
        alignItems: 'center',
        marginLeft:'15px'
        // 탭 사이의 공간을 줄여 사진과 유사하게 만듭니다.
    },
    tabItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 10px', // 탭 간의 가로 간격
        cursor: 'pointer',
        height: '100%',
        justifyContent: 'flex-end', // 밑줄을 바닥에 맞춥니다.
        // 탭 텍스트에만 상단 패딩을 줄 수도 있습니다.
    },
    tabText: {
        fontSize: '16px',
        paddingBottom: '8px', // 텍스트와 밑줄 사이의 간격
        whiteSpace: 'nowrap', // 텍스트 줄바꿈 방지
    },
    tabUnderline: {
        width: '100%',
        height: '2px', // 밑줄 두께
        // 활성 상태에 따라 색상이 결정됩니다.
    },
    iconGroup: {
        display: 'flex',
        alignItems: 'center',
        marginRight:'15px'
    },
    
buttonBase: {
        backgroundColor: '#000000ff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '6px 15px',
        cursor: 'pointer',
        fontSize: '10px',
    },

  value: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: 0,
  },

container: {
        width: '100%',
        maxWidth: '400px', // 모바일 환경에 맞게 최대 너비 설정
        margin: '20px auto',
    },
    // 사진 속 둥근 박스 스타일
    itemBox: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝 정렬 (파트와 브랜드)
        alignItems: 'center',
        padding: '15px 20px',
        margin: '10px 0',
        backgroundColor: '#ffffff',
        borderRadius: '15px', // 둥근 모서리
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', // 약간의 그림자
        cursor: 'pointer', // 클릭 가능함을 표시
    },
    // 왼쪽 텍스트 그룹 (PART + 브랜드)
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
    },
    // 오른쪽 브랜드/쇼핑몰 이름
    rightName: {
        fontSize: '16px',
        color: '#000000',
    },
    // '브랜드' 텍스트의 붉은색 스타일
    redText: {
        color: '#ff4d4f', // 빨간색 계열
        marginLeft: '5px',
        fontWeight: 'normal',
        fontSize: '14px',
    },


  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        border: '1px solid #eee',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    // padding: '0 5vw', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'1'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
  },
  
  logo: {
    width: '100px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
    width: '30px', 
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },

  infoSection: {
    display: 'flex',
    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',

  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },

  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',

    margin: '5px 0',
  },

  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '10px', // 이미지 사이 간격
    marginTop: '10px',
  },

  dailylookImage: {
    width: '47%', // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    //height: '59vw',
        borderRadius: '8px',
    objectFit: 'cover',

  },

  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      position:'relative'
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      // height: '500px',
      borderRadius: '10px', // 이미지와 같은 모서리 둥글게 처리
      display: 'block', // 인라인 요소의 기본 여백 제거
  },

  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#333333', 
    color: '#ffffff',
    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '8px 15px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '14px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    margin: '20px auto',
    border: '1px solid #ccc',
    borderRadius: '25px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 15px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },

  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
  },
  dropdownButton: {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

  },
  arrow: {
    marginLeft: '10px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '100%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },

    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }
  


}

export default Vote_page;